export const REFRESH_USER_COUNT = "REFRESH_USER_COUNT";

import { get, put, post, destroy } from "utils/fetchRequest";

export const getDeliveryList = async (searchText) => {
  try {
    const result = await get(
      `delivery?1=1${searchText ? `&search=${searchText}` : ""}`
    );

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const createDelivery = async (data) => {
  try {
    const result = await post("delivery", data);

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const updateDelivery = async (id, data) => {
  try {
    const result = await put(`delivery/${id}`, data);

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const deleteDelivery = async (id) => {
  try {
    const result = await destroy(`delivery/${id}`);

    return result;
  } catch (err) {
    return { error: err };
  }
};
